import React from "react";
import { Container, Modal, ModalBody, Button, Label } from "reactstrap";
import Header from "components/Headers/Header";
import VisibilityBoardsWidget from "components/VisibilityBoardsWidget";
import VisibilityExplainerVideos from "components/VisibilityExplainerVideos";
import QrCodeInstructionModal from "components/modals/QrCodeInstructionModal";
import RecommendedTeamatesModal from "components/modals/RecommendedTeamatesModal";

import { useProfileData } from "./hooks/useProfileData";
import ProfileHeader from "./components/ProfileHeader";
import PersonalInfoCard from "./components/PersonalInfoCard";
import AddressCard from "./components/AddressCard";
import PricingCard from "./components/PricingCard";
import SocialMediaCard from "./components/SocialMediaCard";
import ImageUploadCard from "./components/ImageUploadCard";
import QRCodeCard from "./components/QRCodeCard";
import RecommendationCard from "./components/RecommendationCard";
import NoticeCard from "./components/NoticeCard";
import ContractCard from "./components/ContractCard";

import "./styles/profile.scss";

const ProfileDashboard = () => {
  const profile = useProfileData();

  return (
    <>
      <Header />

      <Container fluid className="saas-profile-container">
        {/* Contract Link Banner */}
        <ContractCard
          user={profile.user}
          existSchoolContractCid={profile.existSchoolContractCid}
          contractQuestion={profile.contractQuestion}
          handleContract={profile.handleContract}
          handleNoContract={profile.handleNoContract}
          BtnLoader={profile.BtnLoader}
          schoolAdminData={profile.schoolAdminData}
        />

        {/* Hero Section */}
        <ProfileHeader user={profile.user} />

        {/* Dashboard Cards Grid */}
        <div className="dashboard-grid">
          {/* Visibility widgets aligned in grid */}
          <div style={{ display: "flex", width: "100%" }}>
            <VisibilityBoardsWidget />
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <VisibilityExplainerVideos />
          </div>

          {/* Column 1 */}
          <PersonalInfoCard
            user={profile.user}
            firstName={profile.firstName}
            setFirstName={profile.setFirstName}
            lastName={profile.lastName}
            setLastName={profile.setLastName}
            isEditingPersonal={profile.isEditingPersonal}
            setIsEditingPersonal={profile.setIsEditingPersonal}
            personalSaveLoader={profile.personalSaveLoader}
            handleSavePersonalInfo={profile.handleSavePersonalInfo}
            biography={profile.biography}
            setBiography={profile.setBiography}
          />

          <PricingCard
            user={profile.user}
            uid={profile.uid}
            dispatch={profile.dispatch}
            chatRate={profile.chatRate}
            setChatRate={profile.setChatRate}
            sportBadgeRate={profile.sportBadgeRate}
            setSportBadgeRate={profile.setSportBadgeRate}
            sport={profile.sport}
            setSport={profile.setSport}
            defaultSportProps={profile.defaultSportProps}
            rvLoader={profile.rvLoader}
            handleToggle={profile.handleToggle}
            paypalEmail={profile.paypalEmail}
            setPaypalEmail={profile.setPaypalEmail}
          />

          <AddressCard
            user={profile.user}
            state={profile.state}
            setState={profile.setState}
            city={profile.city}
            setCity={profile.setCity}
            school={profile.school}
            setSchool={profile.setSchool}
            isEdit={profile.isEdit}
            setIsEdit={profile.setIsEdit}
            editLoader={profile.editLoader}
            handleChangeAddress={profile.handleChangeAddress}
            defaultStateProps={profile.defaultStateProps}
            defaultCityProps={profile.defaultCityProps}
            defaultNewSchoolProps={profile.defaultNewSchoolProps}
          />

          {/* Important Notice placed right after AddressCard as requested */}
          <NoticeCard />

          {/* Image & QR Code uploads */}
          <ImageUploadCard
            user={profile.user}
            uid={profile.uid}
            dispatch={profile.dispatch}
            imgLoading={profile.imgLoading}
          />

          <QRCodeCard
            user={profile.user}
            uid={profile.uid}
            dispatch={profile.dispatch}
            qrCodeLoading={profile.qrCodeLoading}
            qrUrl={profile.qrUrl}
            setQrUrl={profile.setQrUrl}
            fields={profile.fields}
            fieldToggle={profile.fieldToggle}
            modalToggle={profile.modalToggle}
          />

          <SocialMediaCard user={profile.user} uid={profile.uid} />

          <RecommendationCard modalToggle={profile.modalToggle} />
        </div>

        {/* Warning instructions banner click modal */}
        <h4 className="mt-4 text-center">
          POST SPORTS EXPERIENCE ON YOUR SOCIAL MEDIA & GIVE FANS LINK:{" "}
          <span
            className="text-primary pointer"
            onClick={() => profile.modalToggle("postWarning")}
            style={{ textDecoration: "underline" }}
          >
            INSTRUCTIONS
          </span>
        </h4>

        {/* Instructions modals */}
        <QrCodeInstructionModal
          isOpen={profile.modals.AthleteInstructions}
          toggle={() => profile.modalToggle("AthleteInstructions")}
        />
        <RecommendedTeamatesModal
          isOpen={profile.modals.promote}
          toggle={() => profile.modalToggle("promote")}
        />
        <Modal
          centered
          isOpen={profile.modals.postWarning}
          toggle={() => profile.modalToggle("postWarning")}
        >
          <ModalBody>
            <Label className="custom-label text-primary">
              <b>Instructions:</b>
            </Label>
            <Label className="custom-checkbox-label text-dark">
              <strong>
                Do not post sensitive personal information online. You cannot
                trust everyone you meet online.
              </strong>
            </Label>
            <div className="text-right">
              <Button color="danger" onClick={() => profile.modalToggle("postWarning")}>
                Close
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default ProfileDashboard;
